import { useReducer } from "react";

const initialState = {
  userProfile: [],
  userVsCapability: [],
};

const userCapabilitiesReducer = (userProfileState, action) => {
  switch (action.type) {
    case "USER_PROFILE":
      return { ...userProfileState, userProfile: action.payload };
    case "USER_VS_CAPABILITY":
      return { ...userProfileState, userVsCapability: action.payload };
    default:
      return userProfileState;
  }
};

export const useUserCapabilitiesReducer = () =>
  useReducer(userCapabilitiesReducer, initialState);
